import React from 'react';
import { AwardIcon, CheckCircleIcon, UsersIcon, ShieldIcon } from 'lucide-react';
export const USPSection = () => {
  const usps = [{
    icon: <AwardIcon size={56} className="text-[#D6281F]" data-id="element-581" data-mp="3e6st859cp5np" />,
    title: 'Vakmanschap',
    points: ['Jarenlange ervaring in premium car styling', 'Oog voor detail bij elke klus', 'Gecertificeerde specialisten']
  }, {
    icon: <CheckCircleIcon size={56} className="text-[#D6281F]" data-id="element-582" data-mp="34fg0lbfqabgm" />,
    title: 'Hoogwaardige Materialen',
    points: ['Uitsluitend premium merken en materialen', 'Langdurige bescherming en afwerking', 'Duurzame resultaten']
  }, {
    icon: <UsersIcon size={56} className="text-[#D6281F]" data-id="element-583" data-mp="2gkdal056u1yk" />,
    title: '100% Maatwerk',
    points: ['Persoonlijke service en advies', 'Op maat gemaakte oplossingen', 'Volledig afgestemd op jouw wensen']
  }, {
    icon: <ShieldIcon size={56} className="text-[#D6281F]" data-id="element-584" data-mp="es7b08hjcv0q" />,
    title: 'Garantie',
    points: ['Volledige tevredenheidsgarantie', 'Professionele nazorg', 'Transparante werkwijze']
  }];
  return <section className="py-24 bg-gradient-to-b from-[#0a0a0a] to-[#121212]" data-id="element-585" data-mp="3kwsffmc29pu1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-586" data-mp="3fy8unp97ek39">
        <div className="text-center mb-16" data-id="element-587" data-mp="3fxpjqshz0vyq">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-588" data-mp="3tpdw8ww4tmg8">
            <span className="text-[#D6281F]" data-id="element-589" data-mp="3toui7r9lri7h">Waarom</span>{' '}
            <span className="text-white" data-id="element-590" data-mp="3pp3g4remlfnn">BKCustoms?</span>
          </h2>
          <p className="text-[#CCCCCC] max-w-2xl mx-auto" data-id="element-591" data-mp="31y6cs30wbqo0">
            Wij onderscheiden ons door kwaliteit, precisie en passie.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10" data-id="element-592" data-mp="2x17mxwo9m5vm">
          {usps.map((usp, index) => <div key={index} className="bg-[#121212] rounded-lg border border-[#222222] hover:border-[#D6281F] transition-all duration-300 p-8 hover:shadow-[0_0_30px_rgba(214,40,31,0.2)] group" data-id="element-593" data-mp="3ax1kxkni3aty" data-mpi={index}>
              <div className="flex justify-center mb-6 transition-transform duration-300 group-hover:scale-110" data-id="element-594" data-mp="q72j7sx1txzs">
                {usp.icon}
              </div>
              <h3 className="text-2xl font-bold text-white mb-5 text-center" data-id="element-595" data-mp="3f2ljvery1w38">
                {usp.title}
              </h3>
              <ul className="text-[#CCCCCC] space-y-3" data-id="element-596" data-mp="3jzbx7ucd6dky">
                {usp.points.map((point, i) => <li key={i} className="flex items-start" data-id="element-597" data-mp="3o3s1jr6bxcy2" data-mpi={i}>
                    <span className="text-[#D6281F] mr-2 text-lg" data-id="element-598" data-mp="3t1bd2jbn7bmb">•</span>
                    <span className="text-sm" data-id="element-599" data-mp="3sz7cobcycuqs">{point}</span>
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
};